const VIN_CHECK_DIVISOR = 11;

const VIN_TRANSLITERATE_TABLE = {
  A: 1,
  B: 2,
  C: 3,
  D: 4,
  E: 5,
  F: 6,
  G: 7,
  H: 8,
  I: 0,
  J: 1,
  K: 2,
  L: 3,
  M: 4,
  N: 5,
  O: 0,
  P: 7,
  Q: 0,
  R: 9,
  S: 2,
  T: 3,
  U: 4,
  V: 5,
  W: 6,
  X: 7,
  Y: 8,
  Z: 9,
};

const VIN_INDEX_WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

export function transliterate_character(char: string) {
  return char.match(/[0-9]/) ? parseInt(char) : VIN_TRANSLITERATE_TABLE[char];
}

export function weighted_value(char: string, index: number) {
  return transliterate_character(char) * VIN_INDEX_WEIGHTS[index];
}

export function calculated_check_digit(vin: string) {
  let vin_check_sum = 0;
  vin.split('').map((char, index) => {
    vin_check_sum += weighted_value(char, index);
  });
  return vin_check_sum % VIN_CHECK_DIVISOR;
}
